<template>
    <a :href="redirectUrl" aria-label="Home" @click.prevent="openUrl(redirectUrl)">
        <img v-if="organizationDetails && organizationDetails.logo_url" :class="imageClass" :src="organizationDetails.logo_url" alt="" aria-hidden="true" />
        <img v-else :class="imageClass" :src="Logo" alt="" aria-hidden="true" />
    </a>
</template>

<script setup>
import Logo from "~img/logo.png";
import { isInIFrame, openUrl } from "~vue/utils";
import { computed, inject } from "vue";

const organizationDetails = inject("organization_details");

const { url } = defineProps({
    url: { type: String, default: "/" },
    imageClass: { type: String, default: "" },
});

const redirectUrl = computed(() => {
    return isInIFrame() ? `${url}?client=teams` : `${url}`;
});
</script>
